// extracted by mini-css-extract-plugin
export default {"textareaField":"styles_textareaField__vo-wb","placeholder":"styles_placeholder__eNK6v","inputField":"styles_inputField__X72U5"};